var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10V6.08268M6.00003 10V6.08268M6.00003 6.08268V5C6.00003 2.79086 7.79089 1 10 1C12.2092 1 14 2.79086 14 5V6.08268M6.00003 6.08268C6.78675 6 7.78926 6 9.18794 6H10.8121C12.2108 6 13.2133 6 14 6.08268M6.00003 6.08268C5.39798 6.14596 4.92231 6.25766 4.49219 6.45483C3.6179 6.85563 2.87775 7.50008 2.36049 8.31092C1.77349 9.23109 1.60366 10.4539 1.264 12.8995C0.827825 16.0399 0.609738 17.6101 1.08927 18.8297C1.51024 19.9003 2.28753 20.793 3.29007 21.3573C4.43205 22 6.01734 22 9.18794 22H10.8121C13.9827 22 15.568 22 16.71 21.3573C17.7125 20.793 18.4898 19.9003 18.9108 18.8297C19.3903 17.6101 19.1722 16.0399 18.7361 12.8995C18.3964 10.4539 18.2266 9.23109 17.6396 8.31092C17.1223 7.50008 16.3822 6.85563 15.5079 6.45483C15.0778 6.25766 14.6021 6.14596 14 6.08268",
    stroke: "#00205E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagBig);
export default __webpack_public_path__ + "static/media/bagBig.48f725239dad93a9f95c13eebd5c2145.svg";
export { ForwardRef as ReactComponent };